import { arrayOf, node, shape, string, bool } from "prop-types";
import useMatchMedia from "../../common/useMatchMedia.js";
import cx from "classnames";

import MultiPromoVideoDesktop from "./MultiPromoVideoDesktop.jsx";
import MultiPromoVideoMobile from "./MultiPromoVideoMobile.jsx";

const propTypes = {
  title: string,
  description: node,
  hideFeatured: bool,
  promos: arrayOf(
    shape({
      title: string,
      description: node,
      displayTextRight: bool,
      link: string,
      linkTarget: string,
      videoId: string,
      playerType: string,
      placeholderImg: string,
    }).isRequired,
  ).isRequired,
};

const MultiPromoVideo = (props) => {
  const { title, description, hideFeatured, promos } = props;
  const featuredPromo = promos[0];

  const isDesktop = useMatchMedia("(min-width: 1024px)");

  return (
    <section
      className={cx("multi-promo-c multi-promo-video js-multi-promo-video", {
        "--text-right": !hideFeatured && featuredPromo.displayTextRight,
      })}
    >
      <div className="multi-promo-c__header">
        {title && <h2 className="multi-promo-c__title">{title}</h2>}
        {description && (
          <div className="multi-promo-c__description">
            <div dangerouslySetInnerHTML={{ __html: description }}></div>
          </div>
        )}
      </div>

      {isDesktop ? (
        <MultiPromoVideoDesktop {...props} />
      ) : (
        <MultiPromoVideoMobile {...props} />
      )}
    </section>
  );
};

MultiPromoVideo.propTypes = propTypes;
export default MultiPromoVideo;
